import { FinanceData } from "../types";
import { getRemainingTimeToEndDate } from "./dateFunctions";

export const getCurrentDailyBudget = (
  income: number,
  expectedBills: number,
  expectedSavings: number,
  financeData: FinanceData
) => {
  let previousExpenses = 0;
  let budgetIncrease = 0;

  const expensesData = financeData.expenses ?? [];
  const extraIncome = financeData.extraIncome ?? [];
  if (expensesData.length > 0) {
    expensesData.forEach((expense) => {
      previousExpenses += expense.amount;
    });
  }
  if (extraIncome.length > 0) {
    extraIncome.forEach((extra) => {
      budgetIncrease += extra.amount;
    });
  }
  const daysRemaining = getRemainingTimeToEndDate(
    new Date(financeData.endDate)
  );
//   return Number(income) + Number(budgetIncrease)
  const totalIncome = Number(income) +
  Number(budgetIncrease);
  const totalExpenses = Number(expectedBills) + Number(previousExpenses) + Number(expectedSavings);

  return daysRemaining > 0 && (totalIncome - totalExpenses) > 0 ? ( (totalIncome - totalExpenses) / daysRemaining).toFixed(2)  : 0 

};
